/**
 * GLAMRDiP Included-in-Kit cutout detector — Joel 2026-07-19 (C2).
 *
 * The LIVE salon Bond/Seal/Glow "Included in the Kit" cards render the product as a CUTOUT that
 * bleeds over a lilac circle halo — which only looks right on transparent-background images. The
 * IG kit-item cards therefore DEFAULT to a safe CONTAINED render (a square sitting inside the
 * circle) so opaque/photographic uploads never become floating white boxes. This script samples
 * each card image for transparency and, only when it finds alpha, upgrades it to the --cutout
 * treatment (salon look). Anything uncertain (opaque, CORS-tainted, error) keeps the contained
 * default. Loaded from layout/theme.liquid (defer) so it also runs on ?view= previews + editor.
 */
(function () {
  'use strict';
  var SEL = '.gd-ig-item__image img, .gd-igkit-contents__image img';

  function markCutout(img) {
    var box = img.closest('.gd-ig-item__image, .gd-igkit-contents__image');
    if (!box) return;
    box.classList.add(
      box.classList.contains('gd-ig-item__image') ? 'gd-ig-item__image--cutout' : 'gd-igkit-contents__image--cutout'
    );
  }

  // Load a CORS copy of the image, sample its edges, and report whether it looks like a cutout
  // (transparent surround). A separate crossOrigin Image keeps the displayed <img> untouched and
  // lets us read pixels; Shopify's CDN sends Access-Control-Allow-Origin so the canvas isn't tainted.
  function detect(src, cb) {
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.decoding = 'async';
    probe.onload = function () {
      try {
        var w = 24, h = 24;
        var c = document.createElement('canvas'); c.width = w; c.height = h;
        var ctx = c.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(probe, 0, 0, w, h);
        var d = ctx.getImageData(0, 0, w, h).data;
        // 4 corners + 4 edge midpoints — a cutout has a transparent surround; a photo does not.
        var pts = [[0, 0], [w - 1, 0], [0, h - 1], [w - 1, h - 1], [w >> 1, 0], [0, h >> 1], [w - 1, h >> 1], [w >> 1, h - 1]];
        var transparent = 0;
        for (var i = 0; i < pts.length; i++) {
          var idx = (pts[i][1] * w + pts[i][0]) * 4;
          if (d[idx + 3] < 240) transparent++;
        }
        cb(transparent >= 2);
      } catch (e) { cb(false); }   // taint / read error → keep the safe contained default
    };
    probe.onerror = function () { cb(false); };
    probe.src = src;
  }

  function process(img) {
    if (!img || img.dataset.gdCutoutChecked) return;
    var src = img.currentSrc || img.src;
    if (!src) return;
    img.dataset.gdCutoutChecked = '1';
    detect(src, function (isCutout) { if (isCutout) markCutout(img); });
  }

  function run() {
    try { document.querySelectorAll(SEL).forEach(process); } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
